module.exports = function getResource(label, vars = []) {
    const resources = {
        back: 'Back',
        retake: 'Retake',
        saveAndContinue: 'Save and Continue',
        signInToSave: 'Sign In to Save'
    };

    return resources[label];
};
